import { useQuery } from 'react-query';

import { QueryKey } from '@ge/models/constants';

import { getExistingDamageDetailsByAssetId } from '../services/damages';

export const useExistingDamageDetails = ({ assetId }) => {
  const params = {
    assetIds: assetId,
    components: 'Main Bearing,Gearbox,Generator,Pitch Bearing',
    status: 'Open',
  };

  const {
    data: _data,
    error,
    isLoading,
  } = useQuery(
    [QueryKey.EXISTING_DAMAGE_DETAILS, params],
    () => getExistingDamageDetailsByAssetId(params),
    {
      enabled: Boolean(assetId),
    },
  );
  return { data: _data?.length ? _data : [], error, isLoading };
};
